import React, { useRef, useState } from 'react';
import { styled } from '@mui/material/styles';
import { Typography } from '@mui/material';
import DialogWithHeader from '../../foundation/DialogWithHeader';
import CustomBR from '../../foundation/CustomBR';
import TextArea from '../../foundation/TextArea';
import Button from '../../foundation/Button';
import { reportJob } from '../../../api/contactus.api';
import { JobViewModel } from '../../../../types/jobs.types';

export type ReportJobModalProps = {
    open?: boolean
    onClose: () => void
    job?: JobViewModel
};

const ReportJobModalStyle = styled('div')`
`;

const MIN_DESCRIPTION_LENGTH = 10;

const ReportJobModal = (props: ReportJobModalProps) => {
    const textareaRef = useRef<HTMLTextAreaElement>(null);
    const [descriptionError, setDescriptionError] = useState<string>();
    if (!props.job) return null;

    const onReportClick = async () => {
        const raw = textareaRef.current?.value ?? '';
        const value = raw.trim();
        if (!value) {
            setDescriptionError('יש למלא את תיאור הדיווח');
            return;
        }
        if (value.length < MIN_DESCRIPTION_LENGTH) {
            setDescriptionError(`יש להזין לפחות ${MIN_DESCRIPTION_LENGTH} תווים`);
            return;
        }
        setDescriptionError(undefined);
        await reportJob(props.job, value);
        props.onClose();
        window.showGlobalModal('דיווח על משרה', 'תודה רבה. הדיווח התקבל בהצלחה ונשתדל לטפל בו במהרה.');
    };

    const onDescriptionChange = () => {
        if (descriptionError) setDescriptionError(undefined);
    };

    return <DialogWithHeader
        open={props.open}
        onClose={props.onClose} title="דווח על בעיה במשרה">
        <ReportJobModalStyle>
            <CustomBR />
            <Typography>אנו לוקחים ברצינות כל דיווח המתקבל מהמשתמשים על משרות במערכת.
השאירו פרטים ליצירת קשר ותיאור של הדיווח</Typography>
            <CustomBR />
            <TextArea
                inputRef={textareaRef}
                required
                fullWidth
                variant="outlined"
                label="תיאור הדיווח על המשרה"
                rows={5}
                error={Boolean(descriptionError)}
                helperText={descriptionError}
                onChange={onDescriptionChange} />
            <CustomBR />
            <Button color="error" fullWidth onClick={onReportClick}>שלח דיווח</Button>
            <CustomBR />
        </ReportJobModalStyle>
    </DialogWithHeader>;
};

export default ReportJobModal;
